const styles = (theme) => ({
  barContainer: {
    position: 'relative',
    height: 10,
    borderRadius: 5,
    backgroundColor: theme.color.black_14,
    lineHeight: 0,
    overflow: 'hidden',
  },
  barContainerExp: {
    position: 'relative',
    height: 6,
    borderRadius: 5,
    backgroundColor: theme.color.black_14,
    lineHeight: 0,
    overflow: 'hidden',
  },
  bar: {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    backgroundColor: theme.color.green_7c,
    height: '100%',
  },
  mpsIndicator: {
    position: 'relative',
    top: -15,
    left: 0,
    bottom: 0,
    borderRight: '2px solid black',
    height: 20,
  },
  mpsIndicatorExp: {
    position: 'relative',
    top: -11,
    left: 0,
    bottom: 0,
    borderRight: '2px solid black',
    height: 16,
  },
  mpsContainer: {
    paddingTop: 5,
  },
  mpsContainerExp: {
    paddingTop: 5,
    height: 17,
  },
  mpsValue: {
    display: 'inline-block',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
  },
  redBar: {
    backgroundColor: theme.color.red_00,
  },
});

export default styles;
